/**
 * Created by vsuthar on 9/14/21
 * File: StringTemplate
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */
import { isValidElement, Fragment } from 'react'

const StringTemplate = (str, data) => {

  if (typeof str === 'string' && (data instanceof Array)) {

    return str.replace(/({\d})/g, (i) => {
      return data[i.replace(/{/, '').replace(/}/, '')]
    })
  }
  else if (typeof str === 'string' && isValidElement(data)) {
    const stringArray = str.split(/({\d})/g)
    const indices = stringArray.filter(value => /({\d})/g.test(value)).map(value => stringArray.indexOf(value))
    for (const index of indices) {
      stringArray.splice(index, 1, data)
    }
    return <>{[...stringArray].map((v, i) => <Fragment key={i}>{v}</Fragment>)}</>
  }
  else if (typeof str === 'string' && (data instanceof Object)) {

    if (Object.keys(data).length === 0) {
      return str
    }

    for (const key in data) {
      return str.replace(/({([^}]+)})/g, (i) => {
        const key = i.replace(/{/, '').replace(/}/, '')
        if (!data[key]) {
          return i
        }

        return data[key]
      })
    }
  }
  else if ((typeof str === 'string' && data instanceof Array === false) || (typeof str === 'string' && data instanceof Object === false)) {

    return str
  }
  else {

    return false
  }
}

StringTemplate.propTypes = {}
export default StringTemplate

